import { encrypt, decrypt } from './crypto';

const AUTH_TOKEN_KEY = 'kontty_auth_token';
const REMEMBER_KEY = 'kontty_remember';

interface StoredAuth {
  email: string;
  password: string;
  timestamp: number;
}

export const saveAuthCredentials = (email: string, password: string, remember: boolean = false): void => {
  try {
    if (remember) {
      // Save encrypted credentials
      const auth: StoredAuth = {
        email,
        password,
        timestamp: Date.now()
      };
      const encrypted = encrypt(JSON.stringify(auth));
      localStorage.setItem(AUTH_TOKEN_KEY, encrypted);
      localStorage.setItem(REMEMBER_KEY, 'true');
    } else {
      // For session only
      const auth: StoredAuth = {
        email,
        password,
        timestamp: Date.now()
      };
      const encrypted = encrypt(JSON.stringify(auth));
      sessionStorage.setItem(AUTH_TOKEN_KEY, encrypted);
      localStorage.removeItem(REMEMBER_KEY);
    }
  } catch (error) {
    console.error('Error saving auth credentials:', error);
  }
};

export const getStoredAuth = (): StoredAuth | null => {
  try {
    // Check localStorage first (remember me)
    const remembered = localStorage.getItem(REMEMBER_KEY) === 'true';
    const storage = remembered ? localStorage : sessionStorage;
    const encrypted = storage.getItem(AUTH_TOKEN_KEY);
    
    if (!encrypted) return null;

    const decrypted = decrypt(encrypted);
    if (!decrypted) return null;
    
    try {
      const auth = JSON.parse(decrypted) as StoredAuth;

      // Validate timestamp (expire after 30 days if remembered, or 24 hours if session)
      const maxAge = remembered ? 30 * 24 * 60 * 60 * 1000 : 24 * 60 * 60 * 1000;
      if (Date.now() - auth.timestamp > maxAge) {
        clearStoredAuth();
        return null;
      }

      return auth;
    } catch (parseError) {
      console.error('Error parsing auth data:', parseError);
      clearStoredAuth();
      return null;
    }
  } catch (error) {
    console.error('Error retrieving auth:', error);
    clearStoredAuth();
    return null;
  }
};

export const clearStoredAuth = (): void => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(REMEMBER_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
};